import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppWindow, Star, Sparkles, ArrowRight, Plus } from 'lucide-react';
import { fetchApps } from '../../utils/adminApi';

const StatCard = ({ icon: Icon, label, value, color, to }) => (
  <Link to={to} className="bg-white border border-gray-200 rounded shadow-sm p-4 flex items-center justify-between hover:shadow-md transition-shadow">
    <div>
      <div className="text-sm text-gray-600">{label}</div>
      <div className="text-2xl font-bold text-gray-900 mt-0.5">{value}</div>
    </div>
    <div className={`w-11 h-11 rounded flex items-center justify-center ${color}`}>
      <Icon className="w-5 h-5 text-white" />
    </div>
  </Link>
);

const Dashboard = () => {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    fetchApps().then(setApps).catch(() => {});
  }, []);

  const total = apps.length;
  const top = apps.filter((a) => a.listType === 'top').length;
  const main = apps.filter((a) => a.listType === 'main').length;
  const latest = apps.filter((a) => a.listType === 'latest').length;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-4">Dashboard</h1>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
        <StatCard icon={AppWindow} label="Total Apps" value={total} color="bg-blue-600" to="/wp-admin/apps" />
        <StatCard icon={Star} label="Top Apps" value={top} color="bg-yellow-500" to="/wp-admin/apps?list=top" />
        <StatCard icon={AppWindow} label="Main List" value={main} color="bg-green-600" to="/wp-admin/apps?list=main" />
        <StatCard icon={Sparkles} label="Latest" value={latest} color="bg-purple-600" to="/wp-admin/apps?list=latest" />
      </div>
      <div className="bg-white border border-gray-200 rounded shadow-sm p-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold text-gray-900">Quick Actions</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Link to="/wp-admin/apps/new" className="flex items-center justify-between border border-gray-200 rounded px-4 py-3 hover:bg-gray-50">
            <span className="flex items-center gap-2"><Plus className="w-4 h-4 text-blue-600" /> Add a new app (single or bulk)</span>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </Link>
          <Link to="/wp-admin/apps" className="flex items-center justify-between border border-gray-200 rounded px-4 py-3 hover:bg-gray-50">
            <span className="flex items-center gap-2"><AppWindow className="w-4 h-4 text-blue-600" /> Manage all apps (edit / reorder / delete)</span>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </Link>
          <Link to="/wp-admin/settings" className="flex items-center justify-between border border-gray-200 rounded px-4 py-3 hover:bg-gray-50">
            <span className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-blue-600" /> Edit site settings, SEO & Telegram link</span>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </Link>
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between border border-gray-200 rounded px-4 py-3 hover:bg-gray-50">
            <span className="flex items-center gap-2"><ArrowRight className="w-4 h-4 text-blue-600" /> View live site</span>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
